import React from 'react';
import '../../Default.css';
import type Videos_Container from './videoType'
import video_file from './video.json'
const videos_containers: Videos_Container[] = video_file as any;




function Dance() {
    return (
      <>
        <div className="page-title">
          Dance & songs
        </div>
        <div className='boxes-contener'>
          {videos_containers.map((elem, index) => <>
            <div className='text-box-header' key={index}>{elem.title}</div>
            {elem.videos.map((video, index) => <div key={index} style={{width: '100%'}}>
              <div className='text-box-subheader'>{video.title}</div>
              <iframe width="100%" height="250" src={video.link+"?enablejsapi=1"} title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>)}
          </>)}
        </div>
      </>
    );
}

export default Dance;
